export const UPDATE_FACES_VALUES = 'UPDATE_FACES_VALUES';
export const UPDATE_FACES_VALUES_SUCCESS = 'UPDATE_FACES_VALUES_SUCCESS';
export const UPDATE_FACES_VALUES_ERROR = 'UPDATE_FACES_VALUES_ERROR';
